export default "__VITE_ASSET__855931d9__"